import {Injectable} from "@angular/core";
import {Config, HeartbeatConfig, TiberEnvironment} from ".";

@Injectable()
export class TiberEnvironmentProvider implements TiberEnvironment {
    production = false;
    syncfusionLicense = 'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXhcdXVTR2hcUEFyWUZWYE4=';
    anychartLicense = 'tiberhealth.com-6710e107-2ec826cc';
    config = {
        apiHost: null,
        ltiTool: false
    } as Config;
    heartbeatConfig = {} as HeartbeatConfig;
    spa = "";
};
